import { Dataset } from '../../../../types/types';

export const resolveExportItemNames = (
  dataset: Dataset,
  itemNames: string[] | undefined,
  includeIdItem: boolean
): string[] | undefined => {
  if (!itemNames) {
    return undefined;
  }

  const idItem: string | undefined = dataset.idItem;

  // Only subset grouping reads the id, and the synthetic _id is not a server column.
  if (!includeIdItem || !idItem || itemNames.includes(idItem)) {
    return itemNames;
  }

  return [...itemNames, idItem];
};
